// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import ReviewSideBar from 'components/organisms/ReviewSideBar'
import ReputationListHeader from 'components/organisms/ReputationListHeader'
import ReputationListItem from 'components/molecules/ReputationListItem'

import Pager from 'components/organisms/ListPager'

const MainContainerInner = styled.div`
  padding: 32px 0;
  background: #fff;
  border-bottom: 1px solid ${Colors.grayE};
`

const Title = styled.h2`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 1.4;
`

export type PropTypes = {
  owner: Object,
  room: Object,
  summary: Object,
  reputations: Object,
  pageInfo: Object,
}

export default (props: PropTypes) => (
  <div className="site-main">
    <MainContainerInner>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-4">
            <ReviewSideBar owner={props.owner} room={props.room} />
          </div>
          <div className="col-sm-12 col-md-8">
            <Title>{i18n.t('page.review.title')}</Title>
            <ReputationListHeader {...props.summary} />
            <div>
              {props.reputations.map((reputation, index) => (
                <ReputationListItem
                  key={`reputation_list_item_${index}`}
                  owner={props.owner}
                  reputation={reputation}
                />
              ))}
            </div>
            <Pager {...props.pageInfo} />
          </div>
        </div>
      </div>
    </MainContainerInner>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/pages/RoomReputationListPage/index.jsx